module.exports = __webpack_public_path__ + "static/img/01.50d19c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/01.jpg
// module id = 2rFy
// module chunks = 1